import type { RMReplyTemplate, RMUpdateReplyTemplateSettings } from '@brightlocal/api-client';
import { RM_TEMPLATE_RATING_TYPE } from '@brightlocal/shared';

import type { TemplateFormValues } from '../hooks/useTemplateFormSchema';

/** Create Reply Template body: only the three fields, so the template is account-wide and allowed for auto-replies. */
export const buildCreateTemplateSettings = ({ name, content, reviewRatingType }: TemplateFormValues) => ({
  name,
  content,
  review_rating_type: reviewRatingType
});

/** Update Reply Template body: only the fields that differ from the saved template, so the others keep their value. */
export const getChangedTemplateSettings = ({
  template,
  values
}: {
  template: RMReplyTemplate;
  values: TemplateFormValues;
}) => {
  const settings: RMUpdateReplyTemplateSettings = {};

  if (values.name !== template.name) {
    settings.name = values.name;
  }
  if (values.content !== template.content) {
    settings.content = values.content;
  }
  if (values.reviewRatingType !== template.reviewRatingType) {
    settings.review_rating_type = values.reviewRatingType;
  }

  return settings;
};

/**
 * The template rating a rating radio stands for; `undefined` for a value no rating has.
 * @param value - Value of the radio, the rating written as a string.
 */
export const parseTemplateRatingType = (value: string) =>
  Object.values(RM_TEMPLATE_RATING_TYPE).find((rating) => String(rating) === value);
